import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-headphones" }, null, -1)

import { MessageDialog } from '../../../../framework/frontend/MessageDialog';
import { BlockFactory } from '../../../blockly/BlockFactory';
import { useRoute, useRouter } from 'vue-router';
import { backToBlocklyPage } from "../functional/backToBlocklyPage";
import { block_translation } from '../../../lang/BlockTranslation';

interface Prop{
  type:string,
  assetPath:string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SoundButton',
  props: {
    type: null,
    assetPath: null
  },
  setup(__props: any) {

const props = __props as {
  type:string,
  assetPath:string
};

const t = block_translation;

const route = useRoute();
const router = useRouter();

const addSoundElement = (): void => {
  const factory = new BlockFactory();
  const sound = factory.getSound(props.assetPath);
  factory.addWorkspaceAfterMounted(sound);

  MessageDialog.info(`音楽ブロックを追加しました`);
  backToBlocklyPage(route,router);
};


return (_ctx: any,_cache: any) => {
  return (__props.type === 'sound')
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn btn-outline-dark",
        onClick: addSoundElement
      }, [
        _createTextVNode(_toDisplayString(_unref(t).to("音楽ブロック","sound_block")) + " ", 1),
        _hoisted_1
      ]))
    : _createCommentVNode("", true)
}
}

})